import { defineMessage } from 'services/localization';

export const messages = {
    newRequest: defineMessage('new_request'),
    addUser: defineMessage('add_new_users_1'),
    workflowActivation: defineMessage('activate_the_workflow'),
    workflowStandalone: defineMessage('create'),
    Reject: defineMessage('reject'),
    Approve: defineMessage('approve'),
    workflowStandaloneDescription: defineMessage('purchase_a_subscription_to_create_new_workflows'),
    newRequestDescription: defineMessage('purchase_a_subscription_e_new_approval_requests'),
    workflowActivationDescription: defineMessage('purchase_a_subscription_to_activate_workflows'),
    approvalDecisionDescription: defineMessage('purchase_a_subscription_to_make_approval_decisions'),
    addUserDescription: defineMessage('purchase_a_subscription_to_add_new_users'),
};
